<template>
  <div>
    <title>历史发货记录</title>
    <section class="mainPart">
      <!--S 头部tab-->
      <!-- <header class="tabHeader">
        <p>
          <router-link :to="{name:'销售单管理'}">销售单管理</router-link>
          <router-link :to="{name:'历史发货记录'}"  class="isActive">历史发货记录</router-link>
          <router-link :to="{name:'商品SKU列表'}">商品SKU列表</router-link>
        </p>
      </header> -->
      <CompanyTab :active="currentTit"></CompanyTab>
      <!--E 头部tab-->

      <!--S 发货记录组件-->
      <ShipmentRecord :recordType="1"></ShipmentRecord>
      <!--E 发货记录组件-->
    </section>

  </div>
</template>
<script>
import { Message, MessageBox } from "element-ui";
export default {
  name: 'SalesOrderManage',
  data () {
    return {
     currentTit:1,
    }
  },
  components: {
    CompanyTab: resolve => require(["@/components/ManageFolder/CompanyTab.vue"],resolve), //头部tab组件
    ShipmentRecord: resolve => require(["@/components/OrderFolder/StoreSale/ShipmentRecord.vue"], resolve),//发货记录组件
  },
  watch: {
  },
  methods: {
    
  },
  created() {

  },
  mounted (){

  },
}
</script>

<style scoped>
.mainPart {padding: 20px; height: calc(100% - 50px);}
</style>



// WEBPACK FOOTER //
// src/views/OrderFolder/StoreSale/HistoricalShipmentRecords.vue